import { createSelector } from 'reselect';

// Types
import {
  getApplyPromoCodeFailedSelector,
  getApplyPromoCodeFailedCodeSelector,
  getIsLoadingSelector,
  getOutstandingBalanceSelector,
  getPromoCodeAppliedSelector,
  getApplyPromoCodeLoadingSelector,
  getRewardApplicableSelector,
  getRewardsDiscountTotalSelector,
} from '../../redux/reducers/order-form/orderFormSelector';
import { getPromoCodeError } from '../../redux/reducers/payment/paymentSelector';
import { getPromoCodeEntrySelector } from '../../redux/reducers/form/formSelector';

const applyPromoCodeState = createSelector(
  [
    getApplyPromoCodeFailedSelector,
    getApplyPromoCodeFailedCodeSelector,
    getIsLoadingSelector,
    getOutstandingBalanceSelector,
    getPromoCodeAppliedSelector,
    getApplyPromoCodeLoadingSelector,
    getPromoCodeError,
    getRewardApplicableSelector,
    getRewardsDiscountTotalSelector,
    getPromoCodeEntrySelector,
  ],
  (
    applyPromoCodeFailed,
    applyPromoCodeFailedCode,
    removePromoCodeLoading,
    outstandingBalance,
    promoCodeApplied,
    applyPromoCodeLoading,
    promoCodeError,
    rewardApplicable,
    rewardsDiscountTotal,
    promoCodeEntry,
  ) => {
    const rewardApplied = !!rewardsDiscountTotal;

    return {
      applyPromoCodeFailed,
      applyPromoCodeFailedCode,
      removePromoCodeLoading,
      outstandingBalance,
      promoCodeApplied,
      applyPromoCodeLoading,
      promoCodeError,
      rewardApplicable,
      rewardApplied,
      promoCodeEntry,
    };
  },
);

export default applyPromoCodeState;
